"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BipaAgreementApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class BipaAgreementApi extends runtime.BaseAPI {
    /**
     * Get the bipa agreement language for locationCode in deviceId
     */
    async getBipaAgreementRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getBipaAgreement.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/bipa-agreement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BipaAgreementResponseFromJSON(jsonValue));
    }
    /**
     * Get the bipa agreement language for locationCode in deviceId
     */
    async getBipaAgreement(requestParameters) {
        const response = await this.getBipaAgreementRaw(requestParameters);
        return await response.value();
    }
}
exports.BipaAgreementApi = BipaAgreementApi;
//# sourceMappingURL=BipaAgreementApi.js.map